import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Toast from '../components/Toast/Toast';
import Loading from '../components/Loading/Loading';
import { sendAuthDataViaPostMessage } from '../utils/api';

const AuthCallback = () => {
    const navigate = useNavigate();
    const [errorMessage, setErrorMessage] = useState('');
    const [isLoading, setIsLoading] = useState(true);

    const setTokenCookies = (data) => {
        const accessTokenExpires = new Date(Date.now() + 1 * 864e5).toUTCString(); // 1 day in ms
        const refreshTokenExpires = new Date(Date.now() + 7 * 864e5).toUTCString(); // 7 days in ms
        
        document.cookie = `access_token=${data.access_token}; path=/; expires=${accessTokenExpires}`;
        document.cookie = `refresh_token=${data.refresh_token}; path=/; expires=${refreshTokenExpires}`;
        
        try {
            window?.AndroidBridge?.updateFcmToken();
        } catch (error) {
            console.error('Error updating FCM token via Android bridge:', error);
            // Continue execution even if FCM token update fails
        }
    };

    const getRedirectUrl = () => {
        // Prefer stored redirect (e.g. /nishantkumar)
        const storedRedirect = localStorage.getItem('postLoginRedirect');
        if (storedRedirect) {
            localStorage.removeItem('postLoginRedirect');
            return storedRedirect;
        }

        // Check for source parameter in URL
        const urlParams = new URLSearchParams(window.location.search);
        const source = urlParams.get('source');
        const app_version = urlParams.get('app_version');

        // If source is android, redirect to /?source=android
        if (source === 'android') {
            if (app_version) {
                return `/?source=android&app_version=${app_version}`;
            }
            return '/?source=android';
        }

        // Default fallback
        return '/';
    };

    useEffect(() => {
        const fragment = window.location.hash.substring(1);
        const params = new URLSearchParams(fragment);
        const accessToken = params.get('access_token');
        const uuid = localStorage.getItem('user_id');
        const idToken = params.get('id_token');

        if (accessToken || idToken) {
            fetch(`${process.env.REACT_APP_API_BASE_URL}/users/generate/tokens`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    google_access_token: accessToken,
                    id_token: idToken,
                    uuid: uuid,
                    signupSource: (() => {
                        try {
                            const stored = localStorage.getItem('signupSource');
                            return stored ? JSON.parse(stored) : null;
                        } catch (e) {
                            return null;
                        }
                    })()
                })
            })
            .then(response => response.json())
            .then(response => {
                setIsLoading(false);
                if (!response.status) {
                    setErrorMessage('Authentication failed. Please try again.');
                    setTimeout(() => navigate(getRedirectUrl()), 3000);
                } else {
                    setTokenCookies(response.data);
                    navigate(getRedirectUrl())
                }
            })
            .catch((error) => {
                setIsLoading(false);
                setErrorMessage('Something went wrong. Please try again.');
                setTimeout(() => navigate(getRedirectUrl()), 3000);
            });
        } else {
            setIsLoading(false);
            setErrorMessage('Login failed. Please try again.');
            navigate(getRedirectUrl());
        }
    }, [navigate]);

    return (
        <>
            <Toast message={errorMessage} />
            <Loading isLoading={isLoading} />
        </>
    );
};

export default AuthCallback; 
